import { z } from 'zod';

// Multi-metric trendový graf na profile firmy (Týž. 19) — tržby/zisk z
// FinancialSummaryService + Z"-skóre z AltmanZScoreService.computeHistory,
// spojené podľa `period`.
export const trendPointSchema = z.object({
  period: z.number(),
  revenue: z.number().nullable(),
  netIncome: z.number().nullable(),
  altmanZScore: z.number().nullable(),
});
export type TrendPoint = z.infer<typeof trendPointSchema>;
